/* eslint-disable react/prop-types */
import React, { Fragment } from 'react';
import { getBackgroundImg, getPublicImagePath, getUploadedImagePath, MarkupRender, useAppState } from '@nutastic/nutastic-react-app';
import Fade from 'react-reveal/Fade';
import VideoThumbnail from '../VideoThumbnail';
import VideoHeader from '../VideoHeader';
import PortfolioBox from '../PortfolioBox';

const componentClass = 'caseStudy-page';

const ProjectType1 = ({ title, text, video1 }) => {
    return <section className={`${componentClass}__projectSection page-section page-section--padded page-section--bordered`}>
        <div className="page-section__title page-section__title--alwaysShow">{ title }</div>
        <div className="container">
            <VideoThumbnail image={ video1.image } gif={ video1.image_1 } videoId={ video1.field_1 } useGif={ video1.num_2 } />
            <MarkupRender tagName="p" content={text} className="mt-5" />
        </div>
    </section>;
};

const ProjectType2 = ({ title, text, video1, video2, video3 }) => {
    return <section className={`${componentClass}__projectSection page-section page-section--padded page-section--bordered`}>
        <div className="page-section__title page-section__title--alwaysShow">{ title }</div>
        <div className="container">
            <MarkupRender tagName="p" content={text} className="mb-5" />
            <Fade bottom delay={200} fraction={0.1}>
                <div className="videoBoxes">
                    { video1 && <VideoThumbnail image={ video1.image } gif={ video1.image_1 } videoId={ video1.field_1 } useGif={ video1.num_2 } /> }
                    { video2 && <VideoThumbnail image={ video2.image } gif={ video2.image_1 } videoId={ video2.field_1 } useGif={ video2.num_2 } /> }
                    { video3 && <VideoThumbnail image={ video3.image } gif={ video3.image_1 } videoId={ video3.field_1 } useGif={ video3.num_2 } /> }
                </div>
            </Fade>
        </div>
    </section>;
};

const ProjectType3 = ({ title, text, video1, video2, video3 }) => {
    return <section className={`${componentClass}__projectSection page-section page-section--padded page-section--bordered`}>
        <div className="page-section__title page-section__title--alwaysShow">{ title }</div>
        <div className="container">
            <div className="videoGrid">
                <div className="bigVideo">
                    <VideoThumbnail image={ video1.image } gif={ video1.image_1 } videoId={ video1.field_1 } useGif={ video1.num_2 } />
                </div>
                <div className="smallVideos">
                    <VideoThumbnail image={ video2.image } gif={ video2.image_1 } videoId={ video2.field_1 } useGif={ video2.num_2 } />
                    <VideoThumbnail image={ video3.image } gif={ video3.image_1 } videoId={ video3.field_1 } useGif={ video3.num_2 } />
                </div>
            </div>
            <MarkupRender className="videoGrid--text" tagName="p" content={text} />
        </div>
    </section>;
};

const CaseStudyPage = () => {
    const { caseStudy } = useAppState();
    const {
        headerVideo,
        headerImage,
        title,
        companyLogo,
        content,
        video,
        buttonText,
        buttonLink,
        footerButtonText,
        footerButtonLink,
        sections
    } = caseStudy;

    return <Fragment>
        <VideoHeader image={headerImage} video={headerVideo} />

        <div className={`${componentClass}__aboveTheFold page-section`}>
            <div className="container">
                <div className="aboveTheFold__left">
                    <div>
                        <img src={ getUploadedImagePath(companyLogo) } alt={`${title} - XX - Hello Young Films`} />
                        <h1>{ title }</h1>
                    </div>
                    <MarkupRender className="paragraph" content={content} />
                    { (buttonText && buttonLink) && <a href={buttonLink} className="btn btn-primary" target="_blank" rel="noreferrer">{ buttonText }</a> }
                </div>
                <div className="aboveTheFold__right">
                    <VideoThumbnail image={ video.image } gif={ video.image_1 } videoId={ video.field_1 } useGif={ video.num_2 } />
                    <div className="video-title">
                        <h2>{ video.title }</h2>
                        <span>{ video.content }</span>
                    </div>
                </div>
            </div>
        </div>

        {
            (sections || []).map(section => {
                const { type } = section;
                switch (type) {
                    case 1:
                    case '1':
                        return <ProjectType1 {...section} />;
                    case 2:
                    case '2':
                        return <ProjectType2 {...section} />;
                    case 3:
                    case '3':
                        return <ProjectType3 {...section} />;
                    default:
                        return null;
                }
            })
        }

        <section className="text-center mb-5">
            { (footerButtonText && footerButtonLink) && <a href={footerButtonLink} className="btn btn-secondary mb-5" target="_blank" rel="noreferrer">{ footerButtonText }</a> }
        </section>
    </Fragment>;
};

export default CaseStudyPage;
